export default __webpack_public_path__ + "5e871a64d059f0b752c48a227ff53a0e.png";